import React from 'react';
import { node, bool } from 'prop-types';
import cx from 'classnames';
import styles from './HorizontalSection.scss';

export default function HorizontalSection({ children, center }) {
  return (
    <div className={cx(styles.main, { [styles.center]: center })}>
      {children}
    </div>
  );
}

HorizontalSection.propTypes = {
  center: bool,
  children: node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/HorizontalSection/index.js